import { __assign } from "tslib";
import React from 'react';
export function Toolbar(props) {
    return React.createElement("div", __assign({ className: "rsw-toolbar" }, props));
}
